import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { frontendID } from './defaults/defaults';
import { installApiAuthentication } from './functions/api-auth';
import { getBaseUrl } from '@lib/functions/Navigation';
import { getOAuthConfiguration, refreshOAuthTokens } from './functions/oauth';
import { useLocalState } from './states/LocalState';
import { useUserState } from './states/UserState';

// Global API instance
export const api = axios.create({
  withCredentials: false
});

/*
 * Setup default settings for the Axios API instance.
 */
export function setApiDefaults() {
  const { getHost } = useLocalState.getState();

  api.defaults.baseURL = getHost();
  api.defaults.timeout = 5000;

  api.defaults.withCredentials = false;
  api.defaults.withXSRFToken = false;

  axios.defaults.withCredentials = false;
  axios.defaults.withXSRFToken = false;

}

export const apiAuthentication = installApiAuthentication(api, {
  storage: sessionStorage,
  getConfiguration: getOAuthConfiguration,
  refreshTokens: refreshOAuthTokens,
  onAuthenticationFailure: () => {
    useUserState.getState().clearUserState();
    const base = getBaseUrl();
    window.location.assign(base ? `/${base}/login` : '/login');
  }
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
export function setTraceId() {
  // check if we are in a secure context (https) - if not use of crypto is not allowed
  if (!window.isSecureContext) {
    return '';
  }

  const runID = crypto.randomUUID().replace(/-/g, '');
  const traceid = `00-${runID}-${frontendID}-01`;
  api.defaults.headers['traceparent'] = traceid;

  return runID;
}
export function removeTraceId(traceid: string) {
  void traceid;
  delete api.defaults.headers['traceparent'];
}
